import { useEffect } from 'react';
import { useConfig, usePusher } from '@marvelapp/ballpark-application';
import { PusherEvent } from '@marvelapp/core';
export function usePusherAggregationUpdated(projectPk, callback) {
    const config = useConfig();
    const { pusher } = usePusher();
    useEffect(() => {
        if (!projectPk)
            return;
        const channelName = `${config.pusher.projectChannelPrefix}${projectPk}`;
        const { bindChannel } = pusher.subscribe(channelName);
        const handleAggregationUpdate = (eventData) => {
            callback(eventData);
        };
        const unbindAggregationUpdate = bindChannel(PusherEvent.UserTestAggregated, handleAggregationUpdate);
        return () => {
            unbindAggregationUpdate();
        };
    }, [config.pusher.projectChannelPrefix, pusher, projectPk, callback]);
}
